var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEqual({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    transform: "translate(-305 -293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    transform: "translate(305 293)",
    fill: "#fff",
    stroke: "#e4e7eb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1657",
    "data-name": "Group 1657"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_509",
    "data-name": "Line 509",
    x2: 8,
    transform: "translate(310 300)",
    fill: "none",
    stroke: "#9aa5b1",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_510",
    "data-name": "Line 510",
    x2: 8,
    transform: "translate(310 304)",
    fill: "none",
    stroke: "#9aa5b1",
    strokeLinecap: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEqual);
export default __webpack_public_path__ + "static/media/icon_equal.4858bad3756a021734118224f5072d91.svg";
export { ForwardRef as ReactComponent };